let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iDv2L")).then(() => parcelRequire('euapc'));